module.exports = __webpack_public_path__ + "static/media/Slide46.598be779.JPG";